import type {
    VolumeProfileOverlay,
    VolumeProfileRange,
    VolumeProfileSession,
    VolumeProfileTabId,
    VolumeProfileViewMode,
} from './types';

export type SetTabAction = { type: 'SET_TAB'; tabId: VolumeProfileTabId };
export const setTab = (tabId: VolumeProfileTabId): SetTabAction => ({ type: 'SET_TAB', tabId });

export type SetViewModeAction = { type: 'SET_VIEW_MODE'; viewMode: VolumeProfileViewMode };
export const setViewMode = (viewMode: VolumeProfileViewMode): SetViewModeAction => ({
    type: 'SET_VIEW_MODE',
    viewMode,
});

export type SetSessionAction = { type: 'SET_SESSION'; session: VolumeProfileSession };
export const setSession = (session: VolumeProfileSession): SetSessionAction => ({ type: 'SET_SESSION', session });

export type SetRangeAction = { type: 'SET_RANGE'; range: VolumeProfileRange };
export const setRange = (range: VolumeProfileRange): SetRangeAction => ({ type: 'SET_RANGE', range });

export type ToggleOverlayAction = { type: 'TOGGLE_OVERLAY'; overlay: VolumeProfileOverlay };
export const toggleOverlay = (overlay: VolumeProfileOverlay): ToggleOverlayAction => ({
    type: 'TOGGLE_OVERLAY',
    overlay,
});

export type VolumeProfileAction =
    | SetTabAction
    | SetViewModeAction
    | SetSessionAction
    | SetRangeAction
    | ToggleOverlayAction;
